import React from 'react';
import moment from 'moment';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import ConstrainedTimeInput from '../common/forms/ConstrainedTimeInput';

export default class CrewMemberStartTimeButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            inputValue: '',
        };
    }

    open = () => {
        const { value } = this.props;
        this.setState({ isOpen: true, inputValue: value || '' });
    };

    save = () => {
        const { onChange } = this.props;
        const { inputValue } = this.state;
        onChange(inputValue || null);
        this.setState({ isOpen: false, inputValue: '' });
    };

    clear = () => {
        const { onChange } = this.props;
        onChange(null);
        this.setState({ isOpen: false, inputValue: '' });
    };

    cancel = () => {
        this.setState({ isOpen: false, inputValue: '' });
    };

    render() {
        const { value, label, disabled } = this.props;
        const { isOpen, inputValue } = this.state;
        const hasOverride = !!value;
        const isValidTime = moment(inputValue, 'HH:mm', true).isValid();

        return (
            <>
                <Button
                    color={hasOverride ? 'success' : 'secondary'}
                    outline={!hasOverride}
                    size="sm"
                    onClick={this.open}
                    title="Set start time"
                    disabled={disabled}
                >
                    <FontAwesomeIcon icon={faClock} className="mr-1" />
                    {hasOverride && <span className="ms-1">{value}</span>}
                </Button>

                <Modal isOpen={isOpen} toggle={this.cancel} autoFocus={false}>
                    <ModalHeader toggle={this.cancel}>
                        {label ? `Set Start Time - ${label}` : 'Set Start Time'}
                    </ModalHeader>
                    <ModalBody>
                        <ConstrainedTimeInput
                            value={inputValue}
                            onChange={(e) =>
                                this.setState({ inputValue: e.target.value })
                            }
                            autoFocus={true}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color={isValidTime ? 'success' : 'primary'}
                            onClick={this.save}
                            outline={!isValidTime}
                            disabled={!isValidTime}
                        >
                            Save
                        </Button>
                        <Button
                            color="info"
                            disabled={!inputValue}
                            outline
                            onClick={this.clear}
                        >
                            Clear Override
                        </Button>
                        <Button color="warning" onClick={this.cancel}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
